import { object, string } from 'yup';

export const validationSchema = object().shape({
  email: string().email('email address is required').required('email address is required'),
  password: string().required('password is required'),
});
